import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import { EValidityStatus } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { connectSeasonTicket } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { selectPaymentSum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { TState } from '~/src/store';

import DesktopSbp from './Desktop';
import { ICommonSbpProps } from './types';

const SbpPayment = (): JSX.Element => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    const dispatch = useDispatch();
    const { ticketPayment, isUseBonuses, validity, currentPaySum, paySumIsError, paySumIsLoading } = useSelector((state: TState) => ({
        ticketPayment: state.seasonTicketPayment,
        isUseBonuses: state.seasonTicketPayment.bonusesInfo.isUseBonuses,
        validity: state.seasonTicketPayment.bonusesInfo.validity,
        currentPaySum: selectPaymentSum(state),
        paySumIsError: state.seasonTicketPayment.paySumIsError,
        paySumIsLoading: state.seasonTicketPayment.paySumIsLoading,
    }), shallowEqual);

    const { sbpInfo: { isFetching, qrCode, qrLink, result } } = ticketPayment;

    const onShowQrCode = () => {
        if (result === 'error') {
            pushDataLayer('subscription_connect_try_again');
        }
        dispatch(connectSeasonTicket());
    };

    const hasPaySumm = !paySumIsError && !paySumIsLoading;

    const commonProps: ICommonSbpProps = {
        isDisabled: isUseBonuses
            ? (!hasPaySumm || validity !== EValidityStatus.IS_VALID)
            : !hasPaySumm,
        loading: isFetching,
        onClick: onShowQrCode,
    };

    return (isTablet
        ? <Button
            size={'large'}
            bType={'action'}
            {...commonProps}
        >
            {qrLink ? 'Подтвердить' : currentPaySum ? `Оплатить ${currentPaySum} ${RubleSymbol}` : 'Оплатить'}
        </Button>
        : <DesktopSbp
            isQrCodeError={result === 'error'}
            qrCode={qrCode}
            {...commonProps}
        />
    );
};

export default SbpPayment;
